import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { EntityImportValidationError } from "@idw-types/data/entity-import-validation-error";

export const validateVerificationWorkflowRequest = async (
    body: { [key: string]: any }
): Promise<{ data: { [key: string]: Array<EntityImportValidationError> }, error: any }> => {
    const route = apiRoutes.serviceConfiguration.workflowConfig.validate;
    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error };
};